import { MutableRefObject } from 'react';

import { uploadFile, UploadProgress } from './Amplify';

// One file type for every Customer List upload: the platform's upload step and the AI Insights composer
export const CUSTOMER_LIST_FILE_ACCEPT = '.csv';

const CUSTOMER_LIST_UPLOAD_PATH = 'customerLists/';

export const isCustomerListFile = (file: File) => file.name.toLowerCase().endsWith(CUSTOMER_LIST_FILE_ACCEPT);

/**
 * Uploads a Customer List file to the user's private prefix and returns its URI
 * (`REACT_APP_S3_PRIVATE_URI` + `<identity id>/customerLists/<generated name>`), the only form the API's header
 * inspection accepts. `uploadOperationRef` receives the running upload, so it can be cancelled.
 */
export const uploadCustomerListFile = (
  file: File,
  progressCallback?: (progress: UploadProgress) => void,
  uploadOperationRef?: MutableRefObject<unknown>,
) =>
  uploadFile(
    file,
    progressCallback,
    uploadOperationRef,
    {
      bucket: process.env.REACT_APP_S3_BUCKET_NAME,
      url: process.env.REACT_APP_S3_PRIVATE_URI,
      path: CUSTOMER_LIST_UPLOAD_PATH,
    },
    true,
  );
